const OverlayWrap = props => {
  return (
    <div className={`ptm-overlay-wrapper`}>
      <div className={`ptm-overlay-container ptm-body-bg ptm-body-color`}>{props.children}</div>
    </div>
  );
};

export default OverlayWrap;



// WEBPACK FOOTER //
// ./components/OverlayWrap/index.js